import { DarkMode, LightMode } from "@mui/icons-material";
import { IconButton } from "@mui/material";
import { useSettings } from "../settings/use-settings";

export default function ThemeChange(){
  const {settings, saveSettings} = useSettings();
  return settings.theme === 'dark' ? <IconButton color="inherit" onClick={() => saveSettings({theme: 'light'})}><LightMode/>
  </IconButton>:<IconButton color="inherit" onClick={() => saveSettings({theme: 'dark'})}><DarkMode/></IconButton>
}